export { Wallet as default } from './Wallet';
